import React, { useState } from 'react';
import { useSearchParams, Link, useNavigate } from 'react-router-dom';
import api from '../utils/api';
import toast from 'react-hot-toast';
import { Music, Eye, EyeOff } from 'lucide-react';

export default function ResetPasswordPage() {
  const [params] = useSearchParams();
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirm) return toast.error('Le password non corrispondono');
    if (password.length < 8) return toast.error('Minimo 8 caratteri');
    setLoading(true);
    try {
      await api.post('/auth/reset-password', { token: params.get('token'), password });
      toast.success('Password reimpostata!'); navigate('/login');
    } catch (err) { toast.error(err.response?.data?.error || 'Errore'); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-[#1A1A2E] flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-6"><div className="inline-flex items-center justify-center w-14 h-14 rounded-2xl bg-[#E94560] mb-3"><Music size={28} className="text-white" /></div></div>
        <form onSubmit={handleSubmit} className="bg-white rounded-2xl shadow-xl p-7">
          <h2 className="text-xl font-bold text-pn-dark mb-6">Reimposta Password</h2>
          <div className="mb-4"><label className="block text-sm font-medium mb-1">Nuova Password</label><div className="relative"><input type={show?'text':'password'} className="input-field pr-12" value={password} onChange={e=>setPassword(e.target.value)} required placeholder="Minimo 8 caratteri" /><button type="button" onClick={()=>setShow(!show)} className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400">{show?<EyeOff size={18}/>:<Eye size={18}/>}</button></div></div>
          <div className="mb-6"><label className="block text-sm font-medium mb-1">Conferma Password</label><input type="password" className="input-field" value={confirm} onChange={e=>setConfirm(e.target.value)} required placeholder="Ripeti la password" /></div>
          <button type="submit" disabled={loading} className="w-full btn-primary py-3">{loading ? 'Salvataggio...' : 'Reimposta Password'}</button>
        </form>
      </div>
    </div>
  );
}
